import { render, staticRenderFns } from "./userOrgForm.vue?vue&type=template&id=53aecee2&"
import script from "./userOrgForm.vue?vue&type=script&lang=js&"
export * from "./userOrgForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports